import { useState } from 'react'

import { DropForm } from '@/components/drop/DropForm'

export function DropPage() {
  const [verifying, setVerifying] = useState(false)

  return (
    <main
      id="main"
      className="max-w-site px-margin-mobile md:px-margin-desktop mx-auto w-full flex-grow pt-24 pb-24"
    >
      <div className="mx-auto max-w-2xl space-y-8">
        {!verifying && (
          <div className="space-y-8">
            <h1 className="text-headline-lg-mobile text-fg md:text-headline-lg">
              Post a link
            </h1>
            <p className="font-body text-body-md text-fg-muted">
              Paste an https:// referral or discount link. Everyone sees the
              brand and the offer — the URL stays hidden until someone claims
              it.
            </p>
          </div>
        )}
        <DropForm onVerifyingChange={setVerifying} />
      </div>
    </main>
  )
}
